
import Vue from 'vue';

export default Vue.extend({
    name: 'ErrorPage',
    props: {
        configError: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        refresh() {
            window.location.reload();
        },
    },
});
